<template>
  <div class="popup-header">
    <Icon v-if="backLeftIcon" class="popup-header__icon-back" icon="v-left" @click="$emit('close')" />
    <Icon v-if="icon" class="popup-header__icon" :icon="icon" />
    <div class="popup-header__title">{{ title }}</div>
    <Icon v-if="closeIcon" class="popup-header__close" icon="cross" @click="$emit('close')" />
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import Icon from '@/components/Icon.vue'

@Component({
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
      default: () => 'phone',
    },
    backLeftIcon: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    closeIcon: {
      type: Boolean,
      required: false,
      default: () => true,
    },
  },
  components: {
    Icon,
  },
})
export default class PopupHeader extends Vue {
  
}
</script>

<style lang="scss">
.popup-header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 55px;
  background-color: #005CA9;
  color: #fff;
  font-size: 16px;
  padding: 0 20px;

  &__icon-back {
    padding-right: 10px;
    font-size: 30px;
    margin-top: 17px;
  }

  &__icon {
    padding-right: 10px;
    padding-top: 0;
    font-size: 20px;
  }

  &__title {
    flex: 1 0 auto;
    font-family: 'Gotham';
    padding-top: 2px;
  }

  &__close {
    padding-right: 7px;

    &::before {
      vertical-align: middle;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search/fields/PopupHeader.vue